import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import { SpecialPaymentAcknowledgementRuleset } from '../../business/ruleset';

const { specialPaymentAcknowledgement } = loanFormModel.formField;

export class SpecialPaymentAcknowledgementValidation
  implements ValidationSchema
{
  public name = specialPaymentAcknowledgement.name;
  public label = specialPaymentAcknowledgement.getLabel(10, '$1,000.00');
  public type = 'boolean';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = SpecialPaymentAcknowledgementRuleset;

  public when(schema: Yup.BooleanSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);

    return schema.test({
      name: 'specialPaymentAcknowledgementTest',
      test: function (value) {
        if (required) {
          // Field is required - validate it has value and is true
          return (
            value ||
            this.createError({
              message: specialPaymentAcknowledgement.requiredErrorMsg,
            })
          );
        } else {
          // Field is not required - any value is acceptable
          return true;
        }
      },
    });
  }
}
export default new Validation(new SpecialPaymentAcknowledgementValidation());
